
import Vue from 'vue'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import { patchProjectModule } from '@/utils/project'
const PatchProjectModuleDialog = Vue.extend({
    mixins: [],
    components: { DialogTemplate },

    props: {
        props: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: false,
            deleteCodeTxt: '' as string,
        }
    },

    computed: {
        status(): string {
            return this.props.status
        },

        projectModule() {
            return this.props.projectModule
        },
        project() {
            return this.props.project
        },
    },

    methods: {
        disableDeleteCode() {
            const moduleName: string = this.$t(
                `project_modules.${this.projectModule.module.data.id}`
            ).toString()
            return (
                !this.deleteCodeTxt ||
                this.deleteCodeTxt.toLowerCase().trim() !== moduleName.toLowerCase().trim()
            )
        },

        async patch() {
            if (!(this.status === 'deleted' && this.disableDeleteCode())) {
                this.loading = true
                let projectModule = await patchProjectModule(this.projectModule, this.status).catch(
                    () => {
                        this.error = true
                    }
                )

                if (projectModule) {
                    this.$emit('close', projectModule)
                }
                this.loading = false
            }
        },
    },
})

export default PatchProjectModuleDialog
